import React, {useState, useEffect, useRef} from 'react'
import { faPlus, faTimesCircle, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../global/components/Constants';
import {useDispatch, useSelector} from 'react-redux';
import { topicData, setTopic, setTopicComponents } from '../../slices/topicSlice';
import { genNextId, sortById } from '../../utils/globalUtils';
import { parsePhotoUtil } from '../../utils/photoUtils';
import { topicThemes, mPInit, previewInit, entryPoint } from '../../utils/topicUtils';
import { saveTopicComponent, getTopicComponents } from '../../utils/api-services/topic';
import { displayArrowUtil } from '../../utils/topicComponent/arrowUtils';
import MarginPaddingControl from './MarginPaddingControl';

const EditorArrow = ({params}) => {

    const [formId, setFormId] = useState(0);
    const [displayType, setDisplayType] = useState("arrow");
    const [direction, setDirection] = useState("right");
    const [theme, setTheme] = useState(topicThemes[0].Value);
    const [size, setSize] = useState("small");
    const [label, setLabel] = useState("");
    const [marginPadding, setMarginPadding] = useState(mPInit);
    const [applyBtnHover, setApplyBtnHover] = useState(false);
    const [cancelBtnHover, setCancelBtnHover] = useState(false);
    const [frmError, setFrmError] = useState("");
    const [posting, setPosting] = useState(false);
    const fileInputElem = useRef();

    const tpicData = useSelector(topicData);
    const dispatch = useDispatch();
    const topic = tpicData.topic;
    const topicComponents = tpicData.topicComponents;
    const width = 300;
    const height = 150;

    useEffect(()=>{
        presetForm();
    }, []);

    function presetForm(){
        const obj = params.obj;
        if(obj != null){
            setFormId(obj.Id);
            const content = JSON.parse(obj.Content);
            setDisplayType(content.Display);
            setDirection(content.Direction);
            setTheme(content.Theme);
            setSize(content.Size);
            setLabel(content.Label);
            setMarginPadding(content.MarginPadding);
        }else{
            setSize("large");
        }
    }

    const handleApplyBtnHover = (status) => {
        setApplyBtnHover(status);
    };

    const handleCancelBtnHover = (status) => {
        setCancelBtnHover(status);
    };

    const apply = async () => {

        setFrmError("");

        if(displayType == ""){
            setFrmError("Please select display type");
            return;
        }

        if(direction == ""){
            setFrmError("Please select direction");
            return;
        }

        if(theme == ""){
            setFrmError("Please select theme");
            return;
        }

        if(size == ""){
            setFrmError("Please select size");
            return;
        }

        const dataToSave = { 
            Display: displayType,
            Direction: direction,
            Theme: theme,
            Size: size,
            Label: label,
            MarginPadding: marginPadding
        }

        const saveRecord = await saveTopicComponent({
            id: formId,
            topicSlug: topic.Slug,
            componentType: params.componentType,
            containerId: params.containerId,
            content: JSON.stringify(dataToSave),
            editor: params.editor,
            rank: 0,
            photo: ""
        });
                                
        if(saveRecord.Success){
            loadTopicComponents();
        }
                                
        params.close();
    }

    const loadTopicComponents = async () => {
        const data = await getTopicComponents(topic.Slug);
        dispatch(setTopicComponents(data));
    }

    function cancel(){
        clearForm();
        close()
    }
    
    const styles = {
        form:{
            
        },
        body:{
            minHeight: 200,
            marginBottom:30,
            padding: '20px 20px'
        },
        label:{
            color: "#aaa",
            fontSize: 14,
            fontWeight: 500
        },
        labelSm:{
            color: "#999",
            fontSize: 12,
            fontWeight: 500
        },
        input:{
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        descInput:{
            minHeight: 100,
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        selectBtn: {
            textDecoration: 'none',
            fontSize: 16,
        },
        info: {
            fontSize: 13,
        },
        fileInput: {
            display: 'none'
        },
        footer:{
            padding: '20px 20px',
            borderTop: '1px solid #ccc'
        },
        btns:{
            display: 'flex',
        },
        cancelBtn:{
            background: cancelBtnHover? '#666': '#fff',
            color: cancelBtnHover? '#fff': '#333',
            border: '1px solid #bbb',
            fontSize: 14
        },
        applyBtn:{
            background: applyBtnHover? '#666': '#888',
            color: "#fff",
            marginLeft: 'auto',
            fontSize: 14,
            justifyContent: 'flex-end'
        },
        frmError:{
            color: '#990000',
            marginTop: 15,
            fontSize: 14
        },
        preview:{
            padding: '30px 15px',
            borderLeft: '1px solid #efefef'
        }
    }

    function preview(){
        const previewContent = JSON.stringify({
            Display: displayType,
            Direction: direction,
            Theme: theme,
            Size: size,
            Label: label,
            MarginPadding: marginPadding
        });

        return {
            ComponentType: params.componentType,
            ContainerId: params.containerId,
            Content: previewContent
        }
    }

    return (
        <div style={styles.form}>
            <div style={styles.body}>

                <div className='row'>
                    <div className='col-md-6'>
                        <div style={styles.flowForm}>
                            <div className='row'>
                                <div className="col-6 col-md-6 form-group">
                                    <label style={styles.labelSm}>DISPLAY</label>
                                    <select value={displayType} onChange={e => setDisplayType(e.target.value)} style={styles.input} className="form-control form-control-sm">
                                        <option key={1} value={"arrow"}>Arrow</option>
                                        <option key={2} value={"chevron"}>Chevron</option>
                                        <option key={3} value={"circle-arrow"}>Circle Arrow</option>
                                        <option key={4} value={"circle-chevron"}>Circle Chevron</option>
                                        <option key={5} value={"square-arrow"}>Square Arrow</option>
                                        <option key={6} value={"square-chevron"}>Square Chevron</option>
                                    </select>
                                </div>
                                <div className="col-6 col-md-6 form-group">
                                    <label style={styles.labelSm}>DIRECTION</label>
                                    <select value={direction} onChange={e => setDirection(e.target.value)} style={styles.input} className="form-control form-control-sm">
                                        <option key={1} value={"right"}>Right</option>
                                        <option key={2} value={"left"}>Left</option>
                                        <option key={3} value={"up"}>Up</option>
                                        <option key={4} value={"down"}>Down</option>
                                        <option key={5} value={"left-right"}>Left and Right</option>
                                        <option key={6} value={"up-down"}>Up and Down</option>
                                    </select>
                                </div>
                                <div className="col-6 col-md-6 form-group">
                                    <label style={styles.labelSm}>THEME</label>
                                    <select value={theme} onChange={e => setTheme(e.target.value)} className="form-control form-control-sm">
                                        {topicThemes.map(itm=>(
                                            <option key={itm.Id} value={itm.Value}>{itm.Name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-6 col-md-6 form-group">
                                    <label style={styles.labelSm}>SIZE</label>
                                    <select value={size} onChange={e => setSize(e.target.value)} style={styles.input} className="form-control form-control-sm">
                                        <option key={1} value={"small"}>Small</option>
                                        <option key={2} value={"medium"}>Medium</option>
                                        <option key={3} value={"large"}>Large</option>
                                        <option key={4} value={"xlarge"}>X Large</option>
                                        <option key={5} value={"xxlarge"}>XX Large</option>
                                    </select>
                                </div>
                                <div className='col-12 col-md-12 form-group'>
                                    <label style={styles.labelSm}>LABEL</label>
                                    <input type='text' value={label} onChange={e => setLabel(e.target.value)} style={styles.titleInput} className="form-control form-control-sm" placeholder='Enter label (optional)' />                
                                </div>
                                <div className='col-12 col-md-12 form-group'>
                                    <MarginPaddingControl 
                                        marginPadding={marginPadding} 
                                        setMarginPadding={setMarginPadding} 
                                        inline={false} 
                                    />
                                </div>
                                {(frmError != "") && 
                                    <div className='col-12 col-md-12' style={styles.frmError}>{frmError}</div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div style={styles.preview}>
                            {(displayType!="" || direction != "" || theme != "" || size != "" || label != "")? 
                            displayArrowUtil(preview(), entryPoint.editor): previewInit}
                        </div>
                    </div>
                </div>

            </div>
            <div style={styles.footer}>
                <div style={styles.btns}>
                    <Link onClick={()=>cancel()} style={styles.cancelBtn} className='btn' onMouseEnter={()=>handleCancelBtnHover(true)} onMouseLeave={()=>handleCancelBtnHover(false)}>CANCEL</Link>
                    <Link onClick={()=>apply()} style={styles.applyBtn} className='btn' onMouseEnter={()=>handleApplyBtnHover(true)} onMouseLeave={()=>handleApplyBtnHover(false)}>APPLY</Link>
                </div>
            </div>
        </div>
    )
}

export default EditorArrow